"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalSigner = void 0;
var address_1 = require("@celo/utils/lib/address");
var ecdh_1 = require("@celo/utils/lib/ecdh");
var ecies_1 = require("@celo/utils/lib/ecies");
var sign_typed_data_utils_1 = require("@celo/utils/lib/sign-typed-data-utils");
var wallet_base_1 = require("@celo/wallet-base");
// @ts-ignore
var eth_lib_1 = require("eth-lib");
var ethUtil = __importStar(require("ethereumjs-util"));
/**
 * Signs the EVM transaction using the provided private key
 */
var LocalSigner = /** @class */ (function () {
    function LocalSigner(privateKey) {
        this.privateKey = privateKey;
    }
    LocalSigner.prototype.getNativeKey = function () {
        return this.privateKey;
    };
    LocalSigner.prototype.signTransaction = function (addToV, encodedTx) {
        return __awaiter(this, void 0, void 0, function () {
            var hash, signature;
            return __generator(this, function (_a) {
                hash = (0, wallet_base_1.getHashFromEncoded)(encodedTx.rlpEncode);
                signature = eth_lib_1.account.makeSigner(addToV)(hash, this.privateKey);
                return [2 /*return*/, (0, wallet_base_1.decodeSig)(signature)];
            });
        });
    };
    LocalSigner.prototype.signPersonalMessage = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var trimmedKey, pkBuffer, dataBuff, msgHashBuff, sig;
            return __generator(this, function (_a) {
                trimmedKey = (0, address_1.trimLeading0x)(this.privateKey);
                pkBuffer = Buffer.from(trimmedKey, 'hex');
                dataBuff = ethUtil.toBuffer((0, address_1.ensureLeading0x)(data));
                msgHashBuff = ethUtil.hashPersonalMessage(dataBuff);
                sig = ethUtil.ecsign(msgHashBuff, pkBuffer);
                return [2 /*return*/, {
                        v: parseInt(sig.v, 10),
                        r: Buffer.from(sig.r),
                        s: Buffer.from(sig.s),
                    }];
            });
        });
    };
    LocalSigner.prototype.signTypedData = function (typedData) {
        return __awaiter(this, void 0, void 0, function () {
            var dataBuff, trimmedKey, pkBuffer, sig;
            return __generator(this, function (_a) {
                dataBuff = (0, sign_typed_data_utils_1.generateTypedDataHash)(typedData);
                trimmedKey = (0, address_1.trimLeading0x)(this.privateKey);
                pkBuffer = Buffer.from(trimmedKey, 'hex');
                sig = ethUtil.ecsign(dataBuff, pkBuffer);
                return [2 /*return*/, {
                        v: parseInt(sig.v, 10),
                        r: Buffer.from(sig.r),
                        s: Buffer.from(sig.s),
                    }];
            });
        });
    };
    LocalSigner.prototype.decrypt = function (ciphertext) {
        var decryptedPlaintext = (0, ecies_1.Decrypt)(Buffer.from((0, address_1.trimLeading0x)(this.privateKey), 'hex'), ciphertext);
        return Promise.resolve(decryptedPlaintext);
    };
    LocalSigner.prototype.computeSharedSecret = function (publicKey) {
        return Promise.resolve((0, ecdh_1.computeSharedSecret)(this.privateKey, publicKey));
    };
    return LocalSigner;
}());
exports.LocalSigner = LocalSigner;
//# sourceMappingURL=local-signer.js.map